import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addPlanzoneResourceToProjects(
    request: Boundaries["addPlanzoneResourceToProjects"]["request"],
  ): void;
}

function useAddPlanzoneResourceToProjects(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectsRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectsRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectsRequestFailure(resource),
    ),
    addPlanzoneResourceToProjects: core.addPlanzoneResourceToProjects,
  };
}

export { useAddPlanzoneResourceToProjects };
